import SubSections from '~/constants/vdp/subSections';
import InfoSash from './InfoSash';

type OwnProps = {
  badgeText: string;
};

export default function IncentivesBadge({ badgeText }: OwnProps) {
  return (
    <InfoSash
      adobeId="loyalty-incentives-badge"
      analyticsDescription="incentives"
      bgColor="bg-background-success-subtle"
      leadingText={badgeText}
      section={SubSections.Incentives}
      testId="loyalty-incentives-badge"
    />
  );
}
